module.exports = __webpack_public_path__ + "media/bell-blip.e47602c7.wav";